import Vue from "vue";
import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faPlay,
    faSearch,
    faSpinner,
    faTimes,
    faUserMd,
    faVolumeUp,
} from '@fortawesome/free-solid-svg-icons';

import {
    faFacebookF,
    faFacebookSquare,
    faLinkedin,
    faLinkedinIn,
    faTwitter,
    faTwitterSquare,
    faYoutubeSquare
} from '@fortawesome/free-brands-svg-icons';

library.add(
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faChevronDown,
    faCheck,
    faTimes,
    faPlay,
    faSearch,
    faVolumeUp,
    faSpinner,
    faUserMd,
    faYoutubeSquare,
    faFacebookSquare,
    faFacebookF,
    faTwitterSquare,
    faTwitter,
    faLinkedin,
    faLinkedinIn
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
